import React from 'react';
import styled from 'styled-components';

import { CurrencyFormat } from '@lt/components';
import { NBSP } from 'src/constants/common';

import { TEXT } from '../../constants';
import { Title } from '../../styles';

import type { TitleProps } from '../../types';

type TitleLoadedProps = Omit<TitleProps, 'isLoaded'>;

export const TitleLoaded = (props: TitleLoadedProps) => {
  const {
    destinationText,
    price,
    currencyCode,
    type,
    isMobile,
    className,
    departureCity,
  } = props;

  const { tourType } = TEXT[type];

  const titleText = departureCity
    ? `${tourType} ${destinationText} ${departureCity} `
    : `${tourType} ${destinationText} `;

  return (
    <Title className={className} $isMobile={isMobile}>
      <span>{titleText}</span>

      <PriceWrapper>
        {price && (
          <CurrencyFormat
            value={price}
            currencyCode={currencyCode}
            prefix={`от${NBSP}`}
          />
        )}
      </PriceWrapper>
    </Title>
  );
};

const PriceWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  margin-right: 10px;
`;
